var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "containerReportsCommand" } },
    [
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "0px", "margin-top": "15px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.formFields.client.items,
                      label: _vm.formFields.client.label,
                      "item-text": "desc",
                      "item-value": "cod"
                    },
                    on: {
                      input: function($event) {
                        return _vm.getVehicles()
                      }
                    },
                    model: {
                      value: _vm.formFields.client.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.client, "value", $$v)
                      },
                      expression: "formFields.client.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-combobox", {
                    attrs: {
                      items: _vm.formFields.vehicles.items,
                      label: _vm.formFields.vehicles.label
                    },
                    model: {
                      value: _vm.formFields.vehicles.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.vehicles, "value", $$v)
                      },
                      expression: "formFields.vehicles.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("DateComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateStart.label,
                      "data-vv-name": "fechaRequerida",
                      "error-messages": _vm.errors.collect("fechaRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateStart, "value", $$v)
                      },
                      expression: "formFields.dateStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("DateComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateEnd.label,
                      "data-vv-name": "fechaRequerida",
                      "error-messages": _vm.errors.collect("fechaRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                      },
                      expression: "formFields.dateEnd.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("TimeComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.timeStart.label,
                      "data-vv-name": "fechaRequerida",
                      "error-messages": _vm.errors.collect("fechaRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.timeStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.timeStart, "value", $$v)
                      },
                      expression: "formFields.timeStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("TimeComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.timeEnd.label,
                      "data-vv-name": "fechaRequerida",
                      "error-messages": _vm.errors.collect("fechaRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.timeEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.timeEnd, "value", $$v)
                      },
                      expression: "formFields.timeEnd.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.formFields.typeSend.items,
                      label: _vm.formFields.typeSend.label
                    },
                    model: {
                      value: _vm.formFields.typeSend.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.typeSend, "value", $$v)
                      },
                      expression: "formFields.typeSend.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  staticStyle: {
                    "margin-left": "15px",
                    display: "flex",
                    "justify-content": "flex-start",
                    "align-items": "center"
                  },
                  attrs: { sm3: "", md3: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { margin: "0px !important" },
                      attrs: {
                        color: "primary",
                        flat: "",
                        icon: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.getRecords()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "black" } }, [
                        _vm._v("search")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "v-card",
            { staticStyle: { width: "100%" } },
            [
              _c("MantenedorGrid", {
                ref: "gridComponent",
                staticClass: "ag-theme-material",
                attrs: { id: "gridComponent", "grid-options": _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }